export function groupByArray<TKey, TModel>(xs: Array<TModel>, getKey: (model: TModel) => TKey) {

	let grouped: Map<string, Array<TModel>> = new Map();

	xs.forEach(model => {
		const key = getKey(model);
		const stringKey = key?.toString();
		if (grouped.has(stringKey)) {
			grouped.get(stringKey).push(model);
		}
		else {
			grouped.set(stringKey, [model]);
		}

	});

	return Array.from(grouped, ([key, values]) => ({ key, values }));
}